import React from 'react';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

export const renderTextSegment = (str, isDark) => {
  if (!/>/.test(str)) return str;
  const parts = str.split(/(>)/);
  return parts.reduce((acc, part, i, arr) => {
    if (part === '>') {
      acc.push(
        <ChevronRightIcon key={`chevron-${i}`} style={{ fontSize: 18, verticalAlign: 'middle', margin: '0 -2px', color: isDark ? '#555' : '#ccc' }} />
      );
      return acc;
    }
    const isLast = i === arr.length - 1;
    acc.push(
      <span key={`text-${i}`} style={{ color: isLast ? 'inherit' : (isDark ? '#999' : '#777') }}>
        {part}
      </span>
    );
    return acc;
  }, []);
};

export const renderHighlightedText = (text, matches, highlightClass, isDark, keyToMatch = 'label') => {
  if (!matches || matches.length === 0) {
    return <span style={{ fontSize: '1rem' }}>{renderTextSegment(text, isDark)}</span>;
  }

  let match = matches.find(m => m.key === keyToMatch);

  if (!match && keyToMatch === 'label') {
    match = matches.find(m => m.key === 'searchLabelSpacing');
  }

  if (!match && keyToMatch === 'label') {
    const noSpacingMatch = matches.find(m => m.key === 'searchLabelNoSpacing');
    if (noSpacingMatch) {
      const mappedIndices = noSpacingMatch.indices.map(([start, end]) => {
        let originalStart = 0;
        let originalEnd = 0;
        let noSpacingIdx = 0;
        for (let i = 0; i < text.length; i++) {
          if (!/[-_]/.test(text[i])) {
            if (noSpacingIdx === start) originalStart = i;
            if (noSpacingIdx === end) originalEnd = i;
            noSpacingIdx++;
          }
        }
        return [originalStart, originalEnd];
      });
      match = { indices: mappedIndices };
    }
  }

  if (!match) {
    return <span style={{ fontSize: '1rem' }}>{renderTextSegment(text, isDark)}</span>;
  }

  const isCharHighlighted = new Array(text.length).fill(false);
  if (match && match.indices) {
    match.indices.forEach(([start, end]) => {
      for (let i = Math.max(0, start); i <= Math.min(text.length - 1, end); i++) {
        isCharHighlighted[i] = true;
      }
    });
  }

  const parts = text.split(/(>)/);
  let globalOffset = 0;

  const elements = parts.map((part, i, arr) => {
    if (part === '>') {
      globalOffset += 1;
      return <ChevronRightIcon key={`chevron-${i}`} style={{ fontSize: 18, verticalAlign: 'middle', margin: '0 -2px', color: isDark ? '#555' : '#ccc' }} />;
    }
    
    const isLast = i === arr.length - 1;
    const colorStyle = isLast ? 'inherit' : (isDark ? '#999' : '#777');
    
    const chunkElements = [];
    if (part.length > 0) {
      let currentChunkStart = 0;
      let currentIsHighlighted = isCharHighlighted[globalOffset];

      for (let j = 1; j < part.length; j++) {
        const charGlobalIndex = globalOffset + j;
        if (isCharHighlighted[charGlobalIndex] !== currentIsHighlighted) {
          const chunkStr = part.slice(currentChunkStart, j);
          if (currentIsHighlighted) {
            chunkElements.push(<span key={`chunk-${j}`} className={highlightClass}>{chunkStr}</span>);
          } else {
            chunkElements.push(chunkStr);
          }
          currentChunkStart = j;
          currentIsHighlighted = isCharHighlighted[charGlobalIndex];
        }
      }
      
      const lastChunkStr = part.slice(currentChunkStart);
      if (currentIsHighlighted) {
        chunkElements.push(<span key={`chunk-last-${currentChunkStart}`} className={highlightClass}>{lastChunkStr}</span>);
      } else {
        chunkElements.push(lastChunkStr);
      }
    }

    globalOffset += part.length;

    return (
      <span key={`text-${i}`} style={{ color: colorStyle, fontSize: '1rem' }}>
        {chunkElements}
      </span>
    );
  });

  return <>{elements}</>;
};
